import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  paper: {
    borderRadius: 8,
    width: 640,
    maxWidth: "100%",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    padding: theme.spacing(3),
  },
  title: {
    fontSize: 20,
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  options: {
    gap: theme.spacing(3),
  },
  option: {
    margin: 0,
    alignItems: "flex-start",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    paddingRight: theme.spacing(2),
  },
  optionText: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  optionTitle: {
    fontSize: 20,
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  optionDescription: {
    fontSize: 16,
    lineHeight: "24px",
    color: theme.palette.text.secondary,
  },
  bold: {
    fontWeight: 700,
  },
  divider: {
    backgroundColor: "#eee",
    height: 2,
  },
  salBox: {
    display: "flex",
    alignItems: "flex-start",
    backgroundColor: "rgba(233, 233, 233, 0.3)",
    border: "1px solid #b2b2b2",
    borderRadius: 8,
    padding: theme.spacing(2),
  },
  salIcon: {
    color: "#25D366",
    marginRight: theme.spacing(2),
  },
  salText: {
    color: "#323232",
  },
  salBold: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 1.43,
    letterSpacing: "0.17px",
  },
  salLine: {
    fontSize: 14,
    lineHeight: 1.43,
    letterSpacing: "0.17px",
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));
